/* IZU Paros — size guide behaviour (page + product-page drawer). Everything is rendered server-side; this only
   switches the category tab and the cm / in unit, remembers the unit (localStorage izu_size_unit), keeps ?cat= in the
   page URL, folds "How to measure" on phones, and opens the product-page drawer from [data-szc-open] links. */
(() => {
  if (window.IZUSizeCare) return;
  const KEYS = ["dresses", "tops", "bottoms", "pareos"];
  const phone = matchMedia("(max-width: 600px)");
  const reduce = matchMedia("(prefers-reduced-motion: reduce)");
  const store = {
    get() { try { return localStorage.getItem("izu_size_unit"); } catch (e) { return null; } },
    set(v) { try { localStorage.setItem("izu_size_unit", v); } catch (e) { /* private mode */ } }
  };

  function setUnit(guide, unit) {
    if (unit !== "cm" && unit !== "in") return;
    guide.dataset.unit = unit;
    guide.querySelectorAll("[data-szc-unit]").forEach(b => b.setAttribute("aria-pressed", String(b.dataset.szcUnit === unit)));
  }

  function setTab(guide, key, updateUrl) {
    if (!KEYS.includes(key)) return;
    const panels = guide.querySelector("[data-szc-panels]");
    const swap = () => {
      guide.dataset.active = key;
      guide.querySelectorAll("[data-szc-tab]").forEach(b => b.setAttribute("aria-pressed", String(b.dataset.szcTab === key)));
      guide.querySelectorAll("[data-szc-panel]").forEach(p => { p.hidden = p.dataset.szcPanel !== key; });
    };
    if (reduce.matches || !panels) swap();
    else {
      panels.classList.add("is-fading");
      setTimeout(() => { swap(); requestAnimationFrame(() => panels.classList.remove("is-fading")); }, 200);
    }
    if (updateUrl) {
      const u = new URL(location.href);
      u.searchParams.set("cat", key);
      history.replaceState(history.state, "", u);
    }
    guide.querySelector(`[data-szc-tab="${key}"]`)?.scrollIntoView({ block: "nearest", inline: "nearest" });
  }

  function initGuide(guide) {
    if (guide.dataset.szcReady) return;
    guide.dataset.szcReady = "1";
    const onPage = !!guide.closest("[data-szc-page]");
    const saved = store.get();
    if (saved) setUnit(guide, saved);
    if (onPage) {
      const cat = new URL(location.href).searchParams.get("cat");
      if (cat && KEYS.includes(cat)) setTab(guide, cat, false);
    }
    guide.addEventListener("click", e => {
      const tab = e.target.closest("[data-szc-tab]");
      if (tab) { setTab(guide, tab.dataset.szcTab, onPage); return; }
      const unit = e.target.closest("[data-szc-unit]");
      if (unit) {
        store.set(unit.dataset.szcUnit);
        document.querySelectorAll("[data-szc-guide]").forEach(g => setUnit(g, unit.dataset.szcUnit));
      }
    });
  }

  // "How to measure": a fixed card on larger screens, a closed accordion on phones
  function initMeasure(m) {
    if (m.dataset.szcReady) return;
    m.dataset.szcReady = "1";
    const inDrawer = !!m.closest(".pd-szc");
    if (phone.matches || inDrawer) m.open = false;
    m.querySelector("summary").addEventListener("click", e => {
      if (!phone.matches && !inDrawer) e.preventDefault();
    });
  }

  // Product page: the "Size guide" link opens the drawer (without JS it simply goes to the full guide)
  document.addEventListener("click", e => {
    const link = e.target.closest("[data-szc-open]");
    if (!link || !window.IZUSheet) return;
    const sheet = document.getElementById(link.dataset.szcOpen);
    if (!sheet) return;
    e.preventDefault();
    window.IZUSheet.open(sheet, link);
  });

  function init(root = document) {
    root.querySelectorAll("[data-szc-guide]").forEach(initGuide);
    root.querySelectorAll("[data-szc-measure]").forEach(initMeasure);
  }
  init();
  document.addEventListener("shopify:section:load", e => init(e.target));
  window.IZUSizeCare = { init };
})();
